// Images
import Image1 from '../../assets/images/blog/mistress-md-professional-dominatrix-blog-image (3).jpg';
import Image2 from '../../assets/images/blog/mistress-md-professional-dominatrix-blog-image-xmas.webp';
import Image3 from '../../assets/images/blog/mistress-md-professional-dominatrix-blog-image-somerset.webp';
import Image4 from '../../assets/images/blog/mistress-md-professional-dominatrix-blog-image (4).webp';
import Image5 from '../../assets/images/blog/mistress-md-professional-dominatrix-blog-image-me.jpg';
import Image6 from '../../assets/images/blog/mistress-md-professional-dominatrix-blog-image-upcoming.jpg';
import Image7 from '../../assets/images/blog/mistress-md-professional-dominatrix-blog-image-discount.jpg';
import Image8 from '../../assets/images/blog/mistress-md-professional-dominatrix-blog-image-feb.jpeg';
import Image9 from '../../assets/images/blog/mistress-md-wrestling-ring.jpg';
import Image10 from '../../assets/images/blog/mistress-md-mintstars-clip-store.jpg';

let blogId = 0;

export const tempBlogPosts = [
  {
    id: blogId++,
    title: '💚 My New Clip Store Is Live 💚',
    subTitle:
      'So long to the oldies… all My exclusive clips are now on MintStars.',
    description:
      'Why I’ve left OnlyFans, ManyVids, Darkfans and IWantClips for MintStars: exclusive clips, custom requests, IM chats and anonymous tips in one place.',
    subject: 'Content Platform',
    location: 'Online',
    imageUrl: Image10,
    slug: 'my-new-clip-store-is-live',
    content: [
      {
        type: 'paragraph',
        text: `After growing more and more frustrated over the years with my Fetish content and clips being rejected from loads of the platforms I used…`,
      },
      {
        type: 'paragraph',
        text: `So long to the oldies…`,
      },
      {
        type: 'list',
        items: ['Onlyfans ❌', 'Manyvids ❌', 'Darkfans ❌', 'Iwantclips ❌'],
      },
      {
        type: 'paragraph',
        text: `I’ve now resigned from many of them… been using MINTSTARS for around 2 years now and they truly are the best ever!!!`,
      },
      {
        type: 'paragraph',
        text: `💚 Mintstars 💚`,
      },
      {
        type: 'list',
        items: [
          'Follow Me for FREE',
          'Access & purchase My EXCLUSIVE clips - NOT seen on any other clipstore',
          'IM chats with Me - Day or Night',
          'Request custom clips & pic sets',
          '100% payouts - I now accept all gifts & tips here!!',
        ],
      },
      {
        type: 'paragraph',
        text: `Fans may remain anonymous - all you need is an email address…`,
      },
      {
        type: 'link',
        text: `All are wel-cum to join using My Referral link:`,
        url: 'https://mintstars.com/ref/en9qsnhhz9aku7g0qihzj6eu',
      },
      {
        type: 'link',
        text: `And Follow Me here:`,
        url: 'https://app.mintstars.com/mistressmd',
      },
    ],
    authorId: 1,
    authorName: 'Mistress MD',
    featuredImage: Image10,
    thumbnailImage: Image10,
    isPublished: true,
    publishedAt: '2026-10-20T12:00:00.000Z',
    viewCount: 0,
    tags: ['MintStars', 'Clip Store', 'Exclusive Clips', 'Custom Clips', 'Femdom'],
  },
  {
    id: blogId++,
    title: 'Wrestling Ring Hire',
    subTitle:
      'My wrestling ring is now complete and available for hire in Oldbury, West Midlands.',
    description:
      'My wrestling ring in Oldbury, West Midlands (B69) is now complete and available to hire at £45 per hour for sessions, training, filming and content.',
    subject: 'Wrestling Ring',
    location: 'Oldbury, West Midlands',
    imageUrl: Image9,
    slug: 'wrestling-ring-hire',
    content: [
      {
        type: 'paragraph',
        text: `A quick update to inform all that my wrestling ring is now complete and available for hire.`,
      },
      {
        type: 'paragraph',
        text: `Located in Oldbury, West Midlands, B69.`,
      },
      {
        type: 'paragraph',
        text: `£45 per hour.`,
      },
      {
        type: 'paragraph',
        text: `Perfect for wrestling sessions, training, filming, content creation and private hire.`,
      },
      {
        type: 'paragraph',
        text: `Please contact MD at: Submissionsuiteltd@gmail.com for all booking enquiries.`,
      },
    ],
    authorId: 1,
    authorName: 'Mistress MD',
    featuredImage: Image9,
    thumbnailImage: Image9,
    isPublished: true,
    publishedAt: '2026-05-31T12:00:00.000Z',
    viewCount: 0,
    tags: [
      'Wrestling',
      'Ring Hire',
      'Oldbury',
      'West Midlands',
      'Submission Suite',
    ],
  },
  {
    id: blogId++,
    title:
      'Submission Suite moves to a bigger home: Oldbury, West Midlands, B69',
    subTitle:
      'Spaces now available to hire for personal, photo and filming sessions',
    description:
      'The Submission Suite has moved to a bigger home in Oldbury, West Midlands, with spaces now available to hire for personal, photo and filming sessions.',
    subject: 'Location Update',
    location: 'Oldbury, West Midlands',
    imageUrl: Image8, // change if you want a different image
    slug: 'submission-suite-oldbury-move',
    content: [
      {
        type: 'paragraph',
        text: `* Spaces now available to hire for personal, photo and filming sessions *`,
      },
      {
        type: 'paragraph',
        text: `The walls have echoed with whimpers, the mats have felt the weight of surrender, and the air has crackled with power. But now? Now it’s time to expand.`,
      },
      {
        type: 'paragraph',
        text: `After months of meticulous planning, whispered threats, and the quiet breaking of wills, MistressMD has officially moved into a larger, darker, more commanding domain — one built not just for domination, but for legacy. And at the heart of this new empire lies the long-anticipated: Submission Suite.`,
      },
      {
        type: 'paragraph',
        text: `This is no ordinary playroom. This is a temple of total surrender.`,
      },
      {
        type: 'paragraph',
        text: `A sacred space where knees meet cold floors, where breath is given only when permitted, and where every inch of flesh, every trembling muscle, exists solely to serve the pleasure and dominance of fierce, unapologetic women.`,
      },
      {
        type: 'paragraph',
        text: `Inside the Submission Suite:`,
      },
      {
        type: 'paragraph',
        text: `• Wrestling Ring (coming soon!) & Matted Area — Where female domination isn’t just fantasy, it’s physical. Watch as subs are taken down with brutal grace, pinned beneath powerful thighs, forced to tap out with a whimper — or worse, beg for more.`,
      },
      {
        type: 'paragraph',
        text: `• Service Stations — For kneeling simps, blindfolded and collared, waiting to worship feet, polish boots, or beg for the privilege of cleaning sweat from their goddess’s skin.`,
      },
      {
        type: 'paragraph',
        text: `• Punishment Zones — Canes, paddles, straps — all wielded with precision by mistresses who know exactly how to make a man scream thank you.`,
      },
      {
        type: 'paragraph',
        text: `• Altars of Adoration — Where subs aren’t just punished… they’re used. Forced to chant praise, recite vows of devotion, or offer endless compliments to the goddesses who own them.`,
      },
      {
        type: 'paragraph',
        text: `This is where adoration meets agony. Where submission is not requested — it is extracted.`,
      },
      {
        type: 'paragraph',
        text: `And make no mistake: this new space was built for you. For every simp who aches to kneel. For every sub who dreams of being crushed beneath a dominant woman’s heel. For every voyeur who gets hard watching a man break under the weight of female power.`,
      },
      {
        type: 'paragraph',
        text: `The Submission Suite isn’t just a room. It’s a movement.`,
      },
      {
        type: 'paragraph',
        text: `And MistressMD? She’s not just a dominatrix. She’s the architect of obedience.`,
      },
      {
        type: 'paragraph',
        text: `So if you’ve ever wanted to feel the sting of a mistress’s slap, taste the sole of her boot, beg for mercy while pinned, or simply serve with your entire being — the doors are open. The cameras are rolling. And the hunt for new simps begins.`,
      },
      {
        type: 'paragraph',
        text: `Are you ready to be broken? Or will you remain unworthy? Either way — watch closely. Because in the Submission Suite, power always wins.`,
      },
    ],
    authorId: 1,
    authorName: 'Mistress MD',
    featuredImage: Image8,
    thumbnailImage: Image8,
    isPublished: true,
    publishedAt: '2026-02-11T12:00:00.000Z',
    viewCount: 0,
    tags: ['Submission Suite', 'Dungeon', 'Location Move', 'Sessions'],
  },
  {
    id: blogId++,
    title: '🚨 ‼️ Fetish Frenzy Sale On NOW‼️🚨',
    subTitle:
      'Great opportunity to blow your mind & your load this Friday 13th!!!',
    description:
      'Friday 13th Fetish Frenzy Sale: 15% off ALL of my fetish clips on Clips4Sale all weekend long. Stock up and binge on my filthiest content while it lasts.',
    subject: 'Clip Sale',
    location: '',
    imageUrl: Image7,
    slug: 'fetish-frenzy-sale',
    content: [
      {
        type: 'paragraph',
        text: `Great opportunity to blow your mind & your load this Friday 13th!!! Purchase, stock up, binge & goon all weekend with 15% off ALL Mistress’s filthy, fetish fuelled clips on Clips4Sale 😈🤑💦`,
      },
      {
        type: 'paragraph',
        text: `Use this link for direct access to Mistress’s store: https://www.clips4sale.com/studio/138941/mistressmd---cunnilingus-countess`,
      },
    ],
    authorId: 1,
    authorName: 'Mistress MD',
    featuredImage: Image7,
    thumbnailImage: Image7,
    isPublished: true,
    publishedAt: '2025-06-13T12:00:00.000Z',
    viewCount: 0,
    tags: ['Clips4Sale', 'Discount', 'Fetish', 'Sale'],
  },
  {
    id: blogId++,
    title: '✨ Upcoming session availability ✨',
    subTitle:
      'Let’s kick start May bank holiday weekend with lots of bum bashing & bollock booting!!',
    description:
      'Domination, wrestling and sploshing sessions available 2nd to 9th May, 10am til late, over the bank holiday. Deposit mandatory, filming also available.',
    subject: 'Upcoming Sessions',
    location: '',
    imageUrl: Image1,
    slug: 'upcoming-sessions',
    content: [
      {
        type: 'paragraph',
        text: `Let’s kick start May bank holiday weekend with lots of bum bashing & bollock booting!! `,
      },
      {
        type: 'paragraph',
        text: `Sessions available: `,
      },
      {
        type: 'paragraph',
        text: `Domination • Wrestling • Sploshing`,
      },
      {
        type: 'paragraph',
        text: `2nd - 9th May`,
      },
      {
        type: 'paragraph',
        text: `10am til late`,
      },
      {
        type: 'paragraph',
        text: `DEPOSIT Mandatory`,
      },
      {
        type: 'paragraph',
        text: `*Filming opportunities also available - hoods & own outfits welcome`,
      },
    ],
    authorId: 1,
    authorName: 'Mistress MD',
    featuredImage: Image5,
    thumbnailImage: Image5,
    isPublished: true,
    publishedAt: '2025-05-01T12:00:00.000Z',
    viewCount: 0,
    tags: ['Sessions', 'Sploshing', 'Wrestling'],
  },
  {
    id: blogId++,
    title: 'First tour of 2025 - Manchester',
    subTitle:
      'Let’s kick start the month of March with my visit to Manchester.',
    description:
      'I’m visiting Manchester from Sunday 2nd to Tuesday 4th March for hotel sessions, plus a wrestle at the Wrestling Factory. Get in touch ASAP to book.',
    subject: 'Tour Announcement',
    location: 'Manchester',
    imageUrl: Image1,
    slug: 'first-tour-2025-manchester',
    content: [
      {
        type: 'paragraph',
        text: `Let’s kick start the month of March with my visit to Manchester to penetrate, beatdown and whip some arse!!!

Current dates: Sunday 2nd - Tues 4th March 

I’ll be holding majority of my sessions in a hotel setting but will also visit the Wrestling Factory for a wrestle whilst in the area.

There may be opportunities to book more time and space whilst there, so if you're still yearning to feel the power of my thighs squeezing the life outta you on the wrestling mats and would like a session - get in touch ASAP.

See you soon Manchester!!! 😈😍💦`,
      },
    ],
    authorId: 1,
    authorName: 'Mistress MD',
    featuredImage: Image1,
    thumbnailImage: Image1,
    isPublished: true,
    publishedAt: '2025-02-06T02:02:59.030Z',
    viewCount: 0,
    tags: ['Tour', 'Manchester', 'Wrestling'],
  },
  {
    id: blogId++,
    title: 'Session Fees Update',
    subTitle:
      'I have been receiving many messages to enquire about my session fees.',
    description:
      'Can’t see all of my session fees on your phone? Here’s an update on the mobile display issue and where to find the same fees on my AdultWork page.',
    subject: 'Session Update',
    location: 'Online',
    imageUrl: '',
    slug: 'session-fees-update',
    content: [
      {
        type: 'paragraph',
        text: `I have been receiving many messages to enquire about my session fees as it appears those accessing my site via mobile are having issues expanding the page to show all fees. 

So until I can sort the issue (can’t say I’m very tech savvy at all 🤦🏽‍♀️) I have a simple screenshot from my Adultwork page which displays the same. Hope this helps you all.

Kinky regards,  
MistressMD 😘`,
      },
    ],
    authorId: 1,
    authorName: 'Mistress MD',
    featuredImage: '',
    thumbnailImage: '',
    isPublished: true,
    publishedAt: '2025-01-09T02:02:59.030Z',
    viewCount: 0,
    tags: ['Update', 'Fees', 'Tech Issues'],
  },
  {
    id: blogId++,
    title: 'Christmas Sessions 18th - 21st December #Worcester',
    subTitle: 'Let’s get into some festive Femdom fun.',
    description:
      'Last chance for sessions with me in Worcester before Christmas, 18th to 21st December. Kneel, confess your festive wishes and get your booking in now.',
    subject: 'Christmas Sessions',
    location: 'Worcester',
    imageUrl: Image2,
    slug: 'christmas-sessions-2024',
    content: [
      {
        type: 'paragraph',
        text: `No. You can’t sit on my knee!!

BUTT what you can do is kneel before me, whilst begging to divulge your wank-fuelled wanton wishes for Christmas 😍

Worship, succumb to those desires & submit your whole body to me…

Becum my new toy for 2025 😈

Last chance #Sessions available before Christmas 18th - 21st December #Worcester 

Wishing for a session before the big man arrives to empty his sack? Best get those bookings in NOW!!`,
      },
    ],
    authorId: 1,
    authorName: 'Mistress MD',
    featuredImage: Image2,
    thumbnailImage: Image2,
    isPublished: true,
    publishedAt: '2024-12-18T02:02:59.030Z',
    viewCount: 0,
    tags: ['Christmas', 'Femdom', 'Sessions'],
  },
  {
    id: blogId++,
    title: 'Somerset Tour',
    subTitle: 'Excited for my upcoming mini tour in Somerset.',
    description:
      'I’m heading south on a mini tour of Somerset, 21st to 23rd September, for real-time BDSM, wrestling and messy sessions. Get your bookings in now.',
    subject: 'Tour Announcement',
    location: 'Somerset',
    imageUrl: Image3,
    slug: 'somerset-tour-2024',
    content: [
      {
        type: 'paragraph',
        text: `Hotel booked & I’m excited much, for my upcoming mini #tour.

I’m heading down south to share some of my sexy & sadistic shenanigans about 😈👸🏾🙇‍♂️

#Somerset 21-23rd Sept 

#Realtime #Online #BDSM #Wrestling #Messy #sessions 

#Subbies & #Fetish fans ~ get your bookings in from now: mistressmd.com

FEMDOM❤️‍🔥WRESTLER❤️‍🔥FINDOM 💦WAM💦`,
      },
    ],
    authorId: 1,
    authorName: 'Mistress MD',
    featuredImage: Image3,
    thumbnailImage: Image3,
    isPublished: true,
    publishedAt: '2024-09-11T02:02:59.030Z',
    viewCount: 0,
    tags: ['Tour', 'Somerset', 'BDSM'],
  },
  {
    id: blogId++,
    title: 'Friday 6th Sept ~ 12-8pm #Worcester',
    subTitle: 'Join me for a live session in Worcester.',
    description:
      'Live and filming sessions in Worcester on Friday 6th September, 12 to 8pm, with my sub. Pegging, foot and boot worship, ballbusting, CBT and more.',
    subject: 'Session Announcement',
    location: 'Worcester',
    imageUrl: Image1,
    slug: 'friday-sept-6th-worcester',
    content: [
      {
        type: 'paragraph',
        text: `I’ll be joined by & accepting #Realtime #live & #filming #sessions with my lil lion #sub 🦁

Cum join us & explore your slutty subbie fantasies 😍

• Pegging  
• Foot & Boot Worship  
• Ballbusting & CBT  
• Sissy sluts cock sucking & cum eating coercion 😋  

And much more…

Get in touch now to get your bookings in!!`,
      },
    ],
    authorId: 1,
    authorName: 'Mistress MD',
    featuredImage: Image1,
    thumbnailImage: Image1,
    isPublished: true,
    publishedAt: '2024-09-03T02:02:59.030Z',
    viewCount: 0,
    tags: ['Live Sessions', 'Worcester', 'Submissive'],
  },
  {
    id: blogId++,
    title: 'Join Me on MintStars😍',
    subTitle: 'Check out my exclusive content on MintStars.',
    description:
      'MintStars is my new favourite platform for all of my femdom, wrestling and sploshing content. No profile needed to buy, plus secret, anonymous tips.',
    subject: 'Content Platform',
    location: 'Online',
    imageUrl: Image1,
    slug: 'join-me-on-mintstars',
    content: [
      {
        type: 'paragraph',
        text: `My new FAVOURITE platform where I’ll be uploading ALL of my Femdom, Wrestling & Sploshing content from now on 👀

NO profile required to purchase my exclusive collectible content, send secret, silent tips PLUS the option to resell the content You purchase 😍🤑

Cum give me a follow here:  
[MintStars Profile](https://app.mintstars.com/mistressmd)

Send surprise, secret & anonymous tips, tributes & cash compliments easily by using this link & scanning my barcode 😉  
[MintStars Payments](https://mintpay.mintstars.com/mistressmd)`,
      },
    ],
    authorId: 1,
    authorName: 'Mistress MD',
    featuredImage: Image1,
    thumbnailImage: Image1,
    isPublished: true,
    publishedAt: '2024-08-28T02:02:59.030Z',
    viewCount: 0,
    tags: ['Content', 'MintStars', 'Fetish'],
  },
  {
    id: blogId++,
    title: '☎️ New Number ☎️',
    subTitle: 'Updated contact details.',
    description:
      'Please take note: my contact telephone number changed on 18th June 2024. The new number is at the bottom of every page, so update your saved details.',
    subject: 'Contact Update',
    location: 'Online',
    imageUrl: Image1,
    slug: 'new-number',
    content: [
      {
        type: 'paragraph',
        text: `Please take note, as of 18/06/2024 my contact telephone number has now changed and is displayed at the bottom of every page.

Kinky regards,  
MistressMD`,
      },
    ],
    authorId: 1,
    authorName: 'Mistress MD',
    featuredImage: Image1,
    thumbnailImage: Image1,
    isPublished: true,
    publishedAt: '2024-06-19T02:02:59.030Z',
    viewCount: 0,
    tags: ['Contact', 'Update', 'New Number'],
  },
  {
    id: blogId++,
    title: 'Goodbye Gloucester 👋🏾',
    subTitle: 'I’m moving my dungeon back to Worcester.',
    description:
      'I’m no longer offering sessions in Gloucester and am moving my dungeon back to Worcester, available again from Wednesday 20th December.',
    subject: 'Location Update',
    location: 'Gloucester',
    imageUrl: Image4,
    slug: 'goodbye-gloucester',
    content: [
      {
        type: 'paragraph',
        text: `A quick update...

As of Monday 18th December I will no longer be offering any sessions in Gloucester.

Currently in the process of moving the last bits of my dungeon back to Worcester 😅

I will be back available from Weds 20th December for all those in need of some festive filth, fumbling and Femdom fuckery, with Me, before Christmas!!! 😈 🎄 🤶🏾

Ho, Ho, Ho... Hoes & Whores...

Submit, Succumb & Sacrifice your submissive souls 🙇‍♂️`,
      },
    ],
    authorId: 1,
    authorName: 'Mistress MD',
    featuredImage: Image4,
    thumbnailImage: Image4,
    isPublished: true,
    publishedAt: '2023-12-17T02:02:59.030Z',
    viewCount: 0,
    tags: ['Location Update', 'Gloucester', 'Worcester'],
  },
  {
    id: blogId++,
    title: 'This Is Me - by MistressMD',
    subTitle: 'A look into the personality and kinks of MistressMD.',
    description:
      'Get to know me: a firm, strict and sadistic Mistress with a playful side. My favourite kinks include medical roleplay, findom, mixed wrestling and more.',
    subject: 'Personal Introduction',
    location: 'Online',
    imageUrl: Image5,
    slug: 'this-is-me-by-mistressmd',
    content: [
      {
        type: 'paragraph',
        text: `I’ve always been quite naturally dominant, strong willed & confident throughout my life, embracing my superior power & sexually seductive nature… to get exactly what I want 😋

I am a firm, stern, strict & very sadistic Mistress 😈 but depending on which ‘subject ’ I have in my clutches & our dynamic; I can also be kind, caring, nurturing & quite comical 🤣 I will joke, smile & laugh with you but don’t get things twisted. I get MY fanny tingling thrills from… hurting, ridiculing, teasing, tormenting, denying & degrading YOU!!

I ❤️ physical & intimate interactions, exploring Fetish events & partake in MANY perverse, passionate & painfully delightful sessions 😍 in real-time & online. Some of MY fave kinks & fetishes include:

💉 Medical Fetish/Nurse Roleplay  
🤑 Financial Domination  
🤼‍♂️ Mixed Wrestling  
🤤 Cuckolding  
🙇‍♂️ Goddess/Body Worship  
🍆 Pegging  
🕯 Wax Play  
❌ Tie, Tease & Deny  
👢 Boots/Shoes/Foot Worship  
📱SPH, JOI, CEI, Tasks & games

🌡Temperature’s a rising? 💊 Need a filthy fix of vitaminMD!! Cum check-in to my Corruption Clinic ~ suitable for Cocks, Cucks & Cunts!! 😍👸🏾😈⛓`,
      },
    ],
    authorId: 1,
    authorName: 'Mistress MD',
    featuredImage: Image5,
    thumbnailImage: Image5,
    isPublished: true,
    publishedAt: '2023-07-20T02:02:59.030Z',
    viewCount: 0,
    tags: ['Introduction', 'Femdom', 'Kinks'],
  },
  {
    id: blogId++,
    title: 'Upcoming Availability…',
    subTitle: 'Check my upcoming availability for sessions.',
    description:
      'My session availability in Gloucester and Worcester for the week of 7th August. Same-day bookings are rare, so pay your £60 deposit 24 hours ahead.',
    subject: 'Session Availability',
    location: 'Gloucester/Worcester',
    imageUrl: Image6,
    slug: 'upcoming-availability',
    content: [
      {
        type: 'paragraph',
        text: `Mistress very rarely allows same day bookings due to other work commitments (night shifts) and traveling between my playspaces - Gloucester & Worcester.

Please request booking and be prepared to pay your £60 deposit at least 24hrs before your desired date to avoid disappointment.

Availability w/c: 7/8/23

Mon: Unavailable  
Tues: Unavailable  
Weds: 11:00 -23:00  
Thurs: 11:00 -23:00  
Fri: 11:00 -23:00  
Sat: Unavailable  
Sun: 18:30 - 23:00`,
      },
    ],
    authorId: 1,
    authorName: 'Mistress MD',
    featuredImage: Image6,
    thumbnailImage: Image6,
    isPublished: true,
    publishedAt: '2023-07-12T02:02:59.030Z',
    viewCount: 0,
    tags: ['Availability', 'Bookings', 'Sessions'],
  },
];
